var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 0.5C2.34375 0.5 0 2.89062 0 5.75V16.25C0 19.1562 2.34375 21.5 5.25 21.5C8.10938 21.5 10.5 19.1562 10.5 16.25V5.75C10.5 2.89062 8.10938 0.5 5.25 0.5ZM8.25 11H2.25V5.75C2.25 1.8125 8.25 1.8125 8.25 5.75V11ZM24.7969 8.70312C21.8438 5.79688 17.1094 5.79688 14.1562 8.70312C11.25 11.6562 11.25 16.3906 14.1562 19.3438C17.1094 22.25 21.8438 22.25 24.7969 19.3438C27.7031 16.3906 27.7031 11.6562 24.7969 8.70312ZM15.0469 11.1875L22.3125 18.4531C17.5781 21.4531 12.0469 15.9219 15.0469 11.1875ZM23.9062 16.8594L16.6406 9.59375C21.375 6.59375 26.9531 12.125 23.9062 16.8594Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.5bc16790.svg";
export { ForwardRef as ReactComponent };